import React from 'react'

import type { CompactCampaignBannerHeaderContentBlock } from '@library/api-menu-experience'
import { CompactCampaignBanner } from '@library/menu-page'
import type { RecipeUUID } from '@library/menu-service'

type CompactCampaignBannerContentBlockWrapperProps = {
  contentBlock: CompactCampaignBannerHeaderContentBlock
}

const onAddClick = () => {}
const onBlockedAddAttempt = () => {}
const onCtaClick = () => {}
const onRecipeClick = () => {}
const onRemoveClick = () => {}

const getRecipeCardState =
  (contentBlock: CompactCampaignBannerHeaderContentBlock) => (recipeId: RecipeUUID) => {
    const recipe = contentBlock.items.find((item) => item.id === recipeId)

    return {
      isInBasket: false,
      isOutOfStock: recipe ? !recipe.isAvailable : false,
    }
  }

export const CompactCampaignBannerContentBlockWrapper = ({
  contentBlock,
}: CompactCampaignBannerContentBlockWrapperProps) => (
  <CompactCampaignBanner
    contentBlock={contentBlock}
    getRecipeCardState={getRecipeCardState(contentBlock)}
    canAddRecipes={true}
    reachedLimit={false}
    onAddClick={onAddClick}
    onBlockedAddAttempt={onBlockedAddAttempt}
    onCtaClick={onCtaClick}
    onRecipeClick={onRecipeClick}
    onRemoveClick={onRemoveClick}
  />
)
